<script setup>
import { ref, computed,onMounted, getCurrentInstance } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { proxy } = getCurrentInstance();

const page = ref(1)
const perPage = ref(15)
const list = computed(() => proxy.$store.state.bankingHistory)
const totalCount = computed(() => proxy.$store.state.bankingHistoryTotal)

const formatAmount = (amount) => {
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0 }).format(amount)
}

const getStatusStyle = (status) => {
  switch (status) {
  case 'CANCEL': return 'color: red;'
  case 'APPROVED': return 'color: #5c7f34;'
  case 'REJECTED': return 'color:rgb(127, 52, 52);'
  case 'PENDING': 
  default: return 'color: #977100FF;'
  }
}

const getStatusText = (status) => {
  switch (status) {
  case 'CANCEL': return 'common.canceled'
  case 'APPROVED': return 'common.approved'
  case 'REJECTED': return 'common.rejected'
  default: return 'common.waiting'
  }
}

const getBankingHistory = async () => {
  await proxy.$store.dispatch('fetchBankingHistory', {
    page: page.value,
    perPage: perPage.value,
  })
}

const handlePageChange = (newPage) => {
  page.value = newPage
  getBankingHistory()
}

onMounted(() => {
  getBankingHistory()
})
</script>

<template>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">{{ t('common.date') }}</th>
        <th scope="col">{{ t('bankinghistory.beforeBalance') }}</th>
        <th scope="col">{{ t('bankinghistory.requestAmount') }}</th>
        <th scope="col">{{ t('bankinghistory.afterBalance') }}</th>
        <th scope="col">{{ t('common.type') }}</th>
        <th scope="col">{{ t('common.status') }}</th>
      </tr>
    </thead>
    <tbody v-if="list.length > 0">
      <tr v-for="(item, index) in list" :key="index">
        <td>{{ new Date(item.created_at).toLocaleString() }}</td>
        <td>{{ formatAmount(item.amount_before) }}</td>
        <td>{{ formatAmount(item.request_amount) }}</td>
        <td>{{ formatAmount(item.amount_after) }}</td>
        <td :class="item.type === 'RECHARGE' ? 'btn_cs_in' : 'btn_cs_out'">
          <span>{{ t(item.type === 'RECHARGE' ? 'deposit.title' : 'withdrawal.title') }}</span>
        </td>
        <td :style="getStatusStyle(item.status)">
          {{ t(getStatusText(item.status)) }}
        </td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td colspan="100" class="text-center">{{ t('common.noData') }}</td>
      </tr>
    </tbody>
  </table>
  <nav class="custom-pagination">
    <paginate 
      @update:modelValue="handlePageChange" 
      :total-count="totalCount" 
      :limit="perPage" 
      v-model="page"
    />
  </nav>
</template>

<style>
.table {
  width: 100%;
  margin-bottom: 1rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.btn_cs_in span {
  color: #28a745;
}

.btn_cs_out span {
  color: #dc3545;
}

.custom-pagination {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}

th, td {
  padding: 0.75rem;
  vertical-align: middle;
  text-align: center;
}

.text-center {
  text-align: center;
}
</style>
